const combinedJSONURL = "/commercial/drupal/sites/default/files/globalvariables.json";

// new combined URL containing all JSON vars at one place
let Globals;
try {
  const url1 = `${process.env.REACT_APP_ECOMM_URL}${combinedJSONURL}`;
  const resp = await fetch(url1);
  Globals = await resp.json();
} catch (err) {
  if (!Globals) {
    Globals = require("../../json/fallbackglobalvariables.json");
  }
}

const URLS = {
  ...Globals.url,
  documentRespositoryUrl: `${process.env.REACT_APP_ECOMM_URL}${Globals.url.documentRespositoryUrl}`,
  onBridgeDocumentUrl: `${process.env.REACT_APP_ECOMM_URL}${Globals.url.onBridgeDocumentUrl}`
};
const Keywords = {
  account: "my-account",
  buyOnline: "buy-online",
  easyPay: "EasyPay",
  prePay: "PrePay",
  oneTime: "OneTime",
  premiumList: "HPLAWN,UPLAWN,WFLAWN,SIGLAWN",
  prefTextList: [
    "Not Set",
    "Opted Out",
    "SMS / Text",
    "Email",
    "Phone Call",
    "Mail",
  ],
  adminTokenName: "admintoken",
};

export { URLS, Keywords };

export default Globals;
